import classNames from "classnames";
import * as React from "react";
import { ComponentProps, FC } from "react";
import { icon, Icon, IconSize } from "../icons";
import { Qtip } from "./Qtip";
import * as styles from "./TipIcon.less";
import { QTooltipOptions } from "./types";

const tooltipOptions: QTooltipOptions = {
    hide: {
        fixed: true,
        delay: 100,
    },
};

const InfoIcon = React.forwardRef<SVGSVGElement, { className?: string }>((props, ref) => {
    const { className, ...rest } = props;

    return (
        <Icon
            ref={ref}
            title=""
            iconName={icon.info}
            className={classNames(styles.icon, className)}
            aria-label="info-description"
            {...rest}
        />
    );
});

export const TipIcon: FC<ComponentProps<typeof Qtip> & { className?: string; size?: IconSize; inline?: boolean }> = ({
    children,
    className,
    ...props
}) => (
    <Qtip {...{ ...tooltipOptions, ...props }}>
        <InfoIcon className={classNames(styles.icon_color, className)} />
        {children}
    </Qtip>
);
